export default "__VITE_ASSET__Dh3xj8cE__"